import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights, ICustomProperties } from '@microsoft/applicationinsights-web';

import { appInsightsConnectionString } from '../config/appConfig';

type AppInsightsEventName = 'property-data-sync-issue';

export const reactPlugin = new ReactPlugin();

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: appInsightsConnectionString,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
  },
});

export const trackEvent = (name: AppInsightsEventName, properties?: ICustomProperties) =>
  appInsights.trackEvent({ name, properties });

export const trackError = (err: unknown, customProperties?: ICustomProperties) => {
  const convertToError = () =>
    Error(`Converted error - ${String(err)}, JSON stringified - ${JSON.stringify(err)}`);

  appInsights.trackException(
    { exception: err instanceof Error ? err : convertToError() },
    customProperties,
  );
};
